/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Capture_FutureInputs */

const en_capture_future = /** @type {(inputs: Capture_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating the student will also schedule this lesson and its reminders.`)
};

const he_capture_future = /** @type {(inputs: Capture_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יצירת התלמיד תתזמן גם את השיעור הזה ואת התזכורות שלו.`)
};

/**
* | output |
* | --- |
* | "Creating the student will also schedule this lesson and its reminders." |
*
* @param {Capture_FutureInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const capture_future = /** @type {((inputs?: Capture_FutureInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Capture_FutureInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_capture_future(inputs)
	return he_capture_future(inputs)
});